var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPencil({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.961,
    height: 10.961,
    viewBox: "0 0 10.961 10.961",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7523",
    "data-name": "Path 7523",
    d: "M3,11.675v2.283H5.283l6.734-6.734L9.734,4.941ZM13.783,5.459a.606.606,0,0,0,0-.858L12.358,3.176a.606.606,0,0,0-.858,0L10.385,4.29l2.283,2.283,1.114-1.114Z",
    transform: "translate(-3 -2.997)",
    fill: "#646464"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/edit-pencil.af381d715d4688d9be2dc5b2f7c83b94.svg";
export { ForwardRef as ReactComponent };